import _get from 'lodash/get';
import pageNames from './pageNames';
const keys = {
  [pageNames.DEALER_DETAILS]: ['dealerId'],
  [pageNames.MARKETPLACE_DETAILS]: ['listingId']
};
export default function getRequiredKeys(pageName) {
  return _get(keys, pageName, []);
}